import { getElement, getElements, ifSelectorExist } from "./utils";

export const ScheduleEngineLoader = () => {
  const SEisActive = getElement("#se-widget-embed");
  if (ifSelectorExist(SEisActive)) {
    // Function to hide the loader
    function hideLoader() {
      const loader = getElement("#SE_loader");
      if (ifSelectorExist(loader)) {
        loader.classList.remove("open");
      }
    }

    // Function to show the loader
    function showLoader() {
      const loader = getElement("#SE_loader");
      if (ifSelectorExist(loader)) {
        loader.classList.add("open");
      }
    }

    // Callback function for the MutationObserver
    function callback(mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          for (const node of mutation.addedNodes) {
            if (
              node.classList ||
              node.classList.contains("se-widget-iframe-container")
            ) {
              hideLoader();
              // observer.disconnect();
              break;
            }
          }
        }
      }
    }

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the document body for childList changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Function to handle link click
    function handleLinkClick(e) {
      e.preventDefault(); // Prevent the default action of the link
      showLoader();
    }

    // FOR PRODUCTION

    const links = getElements('a[onclick="ScheduleEngine.show()"]');
    links.forEach((link) => {
      link.addEventListener("click", handleLinkClick);
    });
  } else {
    console.warn("ScheduleEngine is not defined");
  }
};

